// Sensory subsection form field enum
export enum SensoryFormField {
  SENSORY_SENSORY_STATUS_EYES = 'medicalBackground/sensory/sensoryStatusEyes',
  SENSORY_SENSORY_STATUS_EARS = 'medicalBackground/sensory/sensoryStatusEars',
  SENSORY_SENSORY_STATUS_NOSE = 'medicalBackground/sensory/sensoryStatusNose',
  SENSORY_SENSORY_STATUS_TOUCH = 'medicalBackground/sensory/sensoryStatusTouch',
  SENSORY_SENSORY_STATUS_TASTE = 'medicalBackground/sensory/sensoryStatusTaste',
  SENSORY_SYSTEM_SUMMARY = 'medicalBackground/sensory/systemSummary'
}
